import { CustomDate } from '@nemuru-eng/js-api-client';

export const convertDatesToLocalDateString = (obj, keysToSkip?: string[]) => {
  if (obj instanceof Date) {
    return new CustomDate(obj).toLocalDateString();
  } else if (typeof obj === 'object' && obj !== null) {
    for (const key in obj) {
      if (!keysToSkip?.includes(key)) {
        obj[key] = convertDatesToLocalDateString(obj[key], keysToSkip);
      }
    }
  }
  return obj;
};
